/**
 * Subscription Info Popup
 *
 * The Recharge subscription widget's benefits list / learn-more link are
 * hidden for a compact layout (see custom.css, rc-benefits__list / rc-learn-more).
 * The delivery-frequency dropdown is NOT hidden; it must stay visible so
 * shoppers can choose an interval. This adds a small trigger under the
 * widget that opens a popup showing the hidden benefits, read live from the
 * widget's Shadow DOM so it stays accurate.
 *
 * Self-contained and self-guarding: does nothing on pages without the widget.
 */
(function () {
  'use strict';

  var WIDGET_SELECTOR = '.recharge-subscription-widget';
  var initialised = false;

  function readDetails() {
    var host = document.querySelector('recharge-subscription-widget');
    var sr = host && host.shadowRoot;
    var out = { benefits: [], plan: '' };
    if (!sr) return out;

    var benefits = sr.querySelector('rc-benefits');
    var broot = benefits && (benefits.shadowRoot || benefits);
    if (broot) {
      out.benefits = Array.prototype.map
        .call(broot.querySelectorAll('li'), function (li) { return li.textContent.trim(); })
        .filter(Boolean);
    }

    var plans = sr.querySelector('rc-selling-plans');
    if (plans) {
      out.plan = (plans.textContent || '')
        .replace(/\s+/g, ' ')
        .replace(/Delivery every/i, '')
        .trim();
    }
    return out;
  }

  function buildModal() {
    var modal = document.createElement('div');
    modal.id = 'sub-info-modal';
    modal.className = 'sub-info-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="sub-info-modal__overlay" data-close></div>' +
      '<div class="sub-info-modal__panel" role="dialog" aria-modal="true" aria-label="Subscription details">' +
      '<button class="sub-info-modal__close" type="button" data-close aria-label="Close">&times;</button>' +
      '<h3 class="sub-info-modal__title"></h3>' +
      '<ul class="sub-info-modal__list"></ul>' +
      '<p class="sub-info-modal__plan"></p>' +
      '</div>';
    // Set text via textContent so the ampersand renders correctly.
    modal.querySelector('.sub-info-modal__title').textContent = 'Subscribe & Save';
    document.body.appendChild(modal);
    return modal;
  }

  /**
   * Recharge serves the discounted-subscription label with a literal HTML
   * entity ("Subscribe &amp; save") even when the Recharge setting reads
   * "Subscribe and save" — a caching/encoding quirk on their side that the
   * theme can't change at the source. Decode &amp; -> & in the widget's text.
   * Safe + idempotent: a no-op once the served value is correct.
   */
  function decodeEntities(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('&amp;') !== -1) {
        node.nodeValue = node.nodeValue.replace(/&amp;/g, '&');
      }
    }
  }

  var entityFixReady = false;
  function setupEntityFix() {
    if (entityFixReady) return;
    var host = document.querySelector('recharge-subscription-widget');
    var sr = host && host.shadowRoot;
    if (!sr) return;
    entityFixReady = true;
    decodeEntities(sr);
    // Re-apply when Recharge re-renders (e.g. on variant/option change).
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        decodeEntities(sr);
      });
    }).observe(sr, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    if (initialised) return;
    var widget = document.querySelector(WIDGET_SELECTOR);
    if (!widget) return;
    initialised = true;

    var trigger = document.createElement('button');
    trigger.id = 'sub-info-trigger';
    trigger.type = 'button';
    trigger.className = 'sub-info-trigger';
    trigger.textContent = 'ⓘ What’s included with Subscribe & Save';
    widget.insertAdjacentElement('afterend', trigger);

    var modal = buildModal();
    var list = modal.querySelector('.sub-info-modal__list');
    var planEl = modal.querySelector('.sub-info-modal__plan');

    function open() {
      var d = readDetails();
      list.innerHTML = '';
      d.benefits.forEach(function (b) {
        var li = document.createElement('li');
        li.textContent = b;
        list.appendChild(li);
      });
      planEl.textContent = d.plan ? 'Delivery: ' + d.plan : '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  // The Recharge widget renders asynchronously, so retry briefly / observe.
  function boot() {
    init();
    setupEntityFix();
    if (initialised && entityFixReady) return;
    var tries = 0;
    var iv = setInterval(function () {
      init();
      setupEntityFix();
      if ((initialised && entityFixReady) || ++tries > 40) clearInterval(iv); // ~10s max
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
